import { inject, Pipe, PipeTransform } from '@angular/core';
import { User } from '../classes/user.class';
import { UserService } from '../services/user/user.service';

// impure: must update when the central user store changes, lookup is a cheap Map get
@Pipe({
    name: 'userById',
    standalone: false,
    pure: false,
})
export class UserByIdPipe implements PipeTransform {
    private userService = inject(UserService);

    transform(id: number | string | null | undefined): User | undefined {
        return this.userService.userById(id);
    }
}
